export const VECTOR_STORE_EXTENSIONS = [
    ".c",
    ".cpp",
    ".cs",
    ".css",
    ".csv",
    ".doc",
    ".docx",
    ".xlsx",
    ".xls",
    ".gif",
    ".go",
    ".html",
    ".java",
    ".jpeg",
    ".jpg",
    ".js",
    ".json",
    ".md",
    ".markdown",
    ".pdf",
    ".php",
    ".pkl",
    ".png",
    ".ppt",
    ".pptx",
    ".py",
    ".rb",
    ".tar",
    ".sh",
    ".tex",
    ".ts",
    ".txt",
    ".webp",
    ".xml",
    ".zip",
];
export const VECTOR_STORE_MIME_TYPES = [
    "application/pdf",
    "text/plain",
    "text/markdown",
    "text/html",
    "application/json",
    "text/csv",
    "text/css",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "text/x-c",
    "text/x-c++",
    "text/x-csharp",
    "text/x-golang",
    "text/x-java",
    "text/javascript",
    "text/x-php",
    "text/x-python",
    "text/x-script.python",
    "text/x-ruby",
    "application/x-sh",
    "text/x-tex",
    "application/typescript",
];
export const OPENAI_SUPPORTED_EXTENSIONS = new Set(VECTOR_STORE_EXTENSIONS.map((ext) => ext.slice(1)));
export const TEXT_BASED_EDA_EXTENSIONS = new Set([
    "lib",
    "lbr",
    "kicad_sym",
    "kicad_mod",
    "kicad_pcb",
    "kicad_sch",
    "kicad_pro",
    "sch",
    "pcb",
    "net",
    "schdoc",
    "prjpcb",
    "brd",
    "dsn",
    "opj",
    "cir",
    "asc",
    "sp",
    "spi",
    "spice",
    "edif",
    "edf",
    "d356",
    "gbr",
    "ger",
    "drl",
    "gko",
    "drill",
    "nc",
    "dxf",
    "step",
    "stp",
    "bom",
    "ipc",
    "tel",
]);
export function getEdaAcceptString() {
    return Array.from(TEXT_BASED_EDA_EXTENSIONS)
        .map((ext) => `.${ext}`)
        .join(",");
}
//# sourceMappingURL=constants.js.map